import type { WebAnalyticsReport } from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-928 — the public-web visit report client (admin-only endpoint).

export class WebAnalyticsApiError extends Error {}

/** `from`/`to` are inclusive UTC days, YYYY-MM-DD. */
export async function fetchWebAnalytics(
  from: string,
  to: string,
): Promise<WebAnalyticsReport> {
  const qs = new URLSearchParams({ from, to });
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/web-analytics?${qs}`,
    {
      headers: tenantHeader(),
      ...withCredentials,
    },
  );
  if (res.status === 401 || res.status === 403) {
    return jsonOr401<WebAnalyticsReport>(res);
  }
  if (!res.ok) throw new WebAnalyticsApiError(`HTTP ${res.status}`);
  return (await res.json()) as WebAnalyticsReport;
}
